module.exports = __webpack_public_path__ + "files/514a4f24df7e9f1c94e9029820cecbf1.png";